<template>
  <modal titulo="Histórico - Geração CNM em Lote" :loading="loading">

    <card titulo="Lotes">
      <card-content>
        <div v-if="!lotes.length" class="text-muted">Nenhum lote encontrado.</div>
        <table v-else class="table table-sm cnm-lote-tabela mb-0">
          <thead>
            <tr>
              <th>Data</th>
              <th>Usuário</th>
              <th class="text-center">Total</th>
              <th class="text-center text-success">Sucesso</th>
              <th class="text-center text-warning">Pulado</th>
              <th class="text-center text-danger">Erro</th>
              <th class="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lote in lotes" :key="lote.id"
                @click="verDetalhes(lote.id)"
                :class="{ 'table-active': lote.id == loteIdSelecionado }"
                style="cursor: pointer">
              <td class="small">{{ lote.cadastro | datahora }}</td>
              <td class="small">{{ lote.usuario_nome || '-' }}</td>
              <td class="text-center">{{ lote.total_itens }}</td>
              <td class="text-center text-success">{{ lote.total_sucesso }}</td>
              <td class="text-center text-warning">{{ lote.total_pulado }}</td>
              <td class="text-center text-danger">{{ lote.total_erro }}</td>
              <td class="text-center">
                <span v-if="lote.concluido" class="badge badge-success">Concluído</span>
                <span v-else class="badge badge-info">Em andamento</span>
              </td>
            </tr>
          </tbody>
        </table>
      </card-content>
    </card>

    <card v-if="loteDetalhe" :titulo="tituloItens">
      <card-content>
        <div style="max-height: 350px; overflow-y: auto;">
          <table class="table table-sm table-bordered mb-0">
            <thead>
              <tr>
                <th>Tipo</th>
                <th>Código</th>
                <th>Status</th>
                <th>CNM / Motivo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in loteDetalhe.itens" :key="item.id">
                <td>{{ item.tipo === 'INDICADOR_REAL' ? 'Matrícula' : 'Reg. Auxiliar' }}</td>
                <td>{{ item.codigo }}{{ item.livro_letra ? '-' + item.livro_letra : '' }}</td>
                <td>
                  <span :class="classeStatus(item.status)">{{ item.status }}</span>
                </td>
                <td class="small">{{ item.cnm || item.mensagem || '-' }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </card-content>
    </card>

    <template #footer>
      <div class="d-flex ml-auto">
        <v-button v-if="lotes.length" :run="exportarXls" class="btn btn-outline-secondary mr-2">
          Exportar XLS
        </v-button>
        <button type="button" @click.prevent="fechar()" class="btn btn-outline-secondary">
          Fechar
        </button>
      </div>
    </template>

  </modal>
</template>

<script>
import CnmLoteBusiness from "@/business/cnm/CnmLoteBusiness.js";
import FrontBusiness from "@/business/FrontBusiness.js";
import Card from "@/components/Layout/components/Card.vue";
import CardContent from "@/components/Layout/components/CardContent.vue";
import Modal from "@/components/Modal.vue";

export default {
  name: "ConsultarCnmLote",
  components: { Modal, Card, CardContent },
  props: {
    loteId: { type: [Number, String], default: null },
  },
  data() {
    return {
      loading: false,
      lotes: [],
      loteDetalhe: null,
      loteIdSelecionado: null,
    };
  },
  computed: {
    tituloItens() {
      const lote = this.lotes.find(l => l.id == this.loteIdSelecionado);
      if (!lote) return 'Itens do lote';
      const data = this.$options.filters.datahora(lote.cadastro);
      return `Itens do lote — ${data}`;
    },
  },
  async mounted() {
    await this.carregar();
    if (this.loteId) {
      await this.verDetalhes(this.loteId);
    } else if (this.lotes.length) {
      await this.verDetalhes(this.lotes[0].id);
    }
  },
  methods: {
    fechar() {
      FrontBusiness.closeModal();
    },

    async carregar() {
      this.loading = true;
      try {
        this.lotes = await CnmLoteBusiness.listar();
      } catch (e) {
        FrontBusiness.showError('Erro', e);
      } finally {
        this.loading = false;
      }
    },

    async exportarXls() {
      try {
        const blob = await CnmLoteBusiness.exportarXls();
        FrontBusiness.downloadFile(blob, 'historico-cnm-lote.xls');
      } catch (e) {
        FrontBusiness.showError('Erro ao exportar', e);
      }
    },

    async verDetalhes(id) {
      this.loteIdSelecionado = id;
      try {
        this.loteDetalhe = await CnmLoteBusiness.detalhar(id);
      } catch (e) {
        FrontBusiness.showError('Erro', e);
      }
    },

    classeStatus: CnmLoteBusiness.classeStatus,
  },
};
</script>

<style lang="scss" scoped>
.cnm-lote-tabela tbody tr:hover {
  background-color: rgba(128, 128, 128, .15);
}
</style>
